class BESSAppProjectProfilerManager extends BESSAppBase {

    constructor(profiler) {
        super();
        this.profiler = profiler;
        this.totalItemTemplate = new Template('' +
            '<div><div class="app-total-item"><span class="app-total-amount"></span><span class="app-total-what"></span></div></div>');
    }

    start() {

    }

    updated() {

    }

    _createTotalItemContent(total, what) {
        return this.totalItemTemplate.build({
            values: {
                '.app-total-amount': total,
                '.app-total-what': what,
            }
        }).html();
    }

    _forEachItem(fn) {
        _.each(this.profiler.data.items, fn.bind(this));
    }
}